import BaseApiAction from '@Actions/base-api-action';

export default class UpdateTeam extends BaseApiAction {
  runAction() {
    super.invokeCloudFunction({
      name: 'teams-updateTeam',
      payload: {
        doc_id: this._payload.doc_id,
        name: this._payload.name,
        group: this._payload.group,
        gender: this._payload.gender.toUpperCase(),
        admins: this._payload.admins,
      },
    });
  }

  onSuccess(data) {
    this._state.admin.teams.events.teamUpdated.emit();
    super.onSuccess(data);
  }
}
